import FontInput from '../../../../components/FontInput/FontInput'
import TextInput from '../../../../components/TextInput/TextInput'
import TextOptions from '../../../../components/TextOptions/TextOptions'
import LetterSpacingInput from '../../../../components/LetterSpacingInput/LetterSpacingInput'
import { useRef } from 'react'
import ColorInput from '../../../../components/ColorInput/ColorInput'
import Dropdown from '../../../../components/Dropdown/Dropdown'

const PlaylistEditModalFolderTab = ({
  values,
  setValue,
  onSaveClick,
  onSavePublishClick,
  publishLabel,
}) => {
  const ref = useRef()

  return (
    <div className="p-6" ref={ref}>
      <h3 className="mb-4">Playlist Folders</h3>
      <h4 className="mb-2">Folder</h4>

      <div className="mt-4">
        <TextOptions
          label="Title"
          values={values.folderTitleText}
          onChange={(value) => setValue('folderTitleText', value)}
          containerRef={ref}
        />
      </div>
      <div className="mt-4">
        <TextOptions
          label="Description"
          values={values.folderDescriptionText}
          onChange={(value) => setValue('folderDescriptionText', value)}
          containerRef={ref}
        />
      </div>

      <h4 className="mb-2 mt-8">Bottom Border</h4>

      <div className="mt-4">
        <ColorInput
          label="Color"
          value={values.folderBorderColor}
          containerRef={ref}
          onChange={(value) => setValue('folderBorderColor', value)}
        />
      </div>

      <h4 className="mb-2 mt-8">Chevron</h4>

      <div className="mt-4">
        <ColorInput
          label="Color"
          value={values.folderChevronColor}
          containerRef={ref}
          onChange={(value) => setValue('folderChevronColor', value)}
        />
      </div>

      <h4 className="mb-2 mt-8">Folder Art</h4>

      <div className="mt-4 ">
        <Dropdown
          label="Folder Art Size"
          options={[
            { id: '', name: 'Hidden' },
            { id: 'small', name: 'Small' },
            { id: 'normal', name: 'Normal' },
            { id: 'large', name: 'Large' },
          ]}
          value={values.folderArtSize}
          onChange={(val) => setValue('folderArtSize', val)}
        ></Dropdown>
      </div>

      <div className="mt-10 mb-4">
        <button
          className="button bg-pink hover:bg-pink-off"
          onClick={onSaveClick}
        >
          Save
        </button>
        <button
          className="button ml-4 text-white-dark"
          onClick={onSavePublishClick}
        >
          {publishLabel}
        </button>
      </div>
    </div>
  )
}

export default PlaylistEditModalFolderTab
